module.exports = __webpack_public_path__ + "static/media/unlimited-features.7e97e67b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unlimited-features.jpg
// module id = 920
// module chunks = 0